import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/observable';

import { Attendee } from '../models/attendee';

@Injectable()
export class AttendeeService {

	constructor(private afDatabase: AngularFireDatabase) { }

	public getAttendees(): Observable<Attendee[]> {
		return this.afDatabase.list('/attendees');
	}

	public addAttendee(attendee: Attendee): string {
		const date = new Date();
		attendee.createdAt = date.getTime();
		attendee.updatedAt = date.getTime();

		return this.afDatabase.list('/attendees').push(attendee).key;
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/services/attendee.service.ts